"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M1 12C1 5.935 5.935 1 12 1c2.45 0 4.768.788 6.705 2.28L16.15 6.6A6.744 6.744 0 0012 5.19 6.817 6.817 0 005.19 12 6.817 6.817 0 0012 18.81c3.024 0 5.594-1.982 6.48-4.715H12v-4.19h11V12c0 6.065-4.935 11-11 11S1 18.065 1 12z" }), "Google");
//# sourceMappingURL=Google.js.map